import { Paper } from "@material-ui/core";
import { useCreateOrUpdateBuildingMedia } from "../../../../graphql/hooks";
import { BuildingMediaType } from "../../../../graphql/models/BuildingMedia";
import { ImageEntry, ImagePicker } from "../../image-picker";

export type AddMediaPaperProps = {
  buildingId: string;
  buildingCode: string;
  buildingMediaType: BuildingMediaType;
  onMediaCreated: (buildingMediaId: string) => void;
};

export function AddMediaPaper(props: AddMediaPaperProps) {
  const { buildingId, buildingCode, buildingMediaType, onMediaCreated } = props;

  const {
    createOrUpdate: createBuildingMedia,
    error,
    loading,
  } = useCreateOrUpdateBuildingMedia("CREATE", {
    onCompleted: ({ createBuildingMedia }) => {
      onMediaCreated(createBuildingMedia.id);
    },
  });

  const onPictureUploaded = (entry: ImageEntry) => {
    createBuildingMedia({
      building: {
        id: buildingId,
        code: buildingCode,
      },
      image: {
        url: entry.url,
      },
      mediaType: buildingMediaType,
    });
  };

  return (
    <Paper elevation={5} style={{ width: 179, height: 160, padding: "0.5rem" }}>
      <ImagePicker
        key={"add-image"}
        width={159}
        height={116}
        onUploaded={onPictureUploaded}
      />
      {loading && "Caricamento in corso.."}
      {error?.message}
    </Paper>
  );
}
